// 在一些关键节点调用，提前发现错误
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function checkProcessEnv(scope: 'all' | 'webpack' | 'node' = 'all') {
  // 历史设计，存在错误使用的情况，继续兼容
  // 正确用法，仅 webpack 作用域有效；此处注入后，部分 nodejs 场景可用
  // 特殊写法，绕过 webpack 编译替换
  if (typeof window === 'undefined') {
    // console.warn('### checkProcessEnv', scope, process.pid)
    ;[
      `process.dev=${
        process.env.NODE_ENV === 'development' ? 'true' : 'false'
      }`,
      'process.browser=false',
      'process.server=true',
      // eslint-disable-next-line no-eval
    ].forEach(eval)
  }

  // nodejs + webpack 作用域有效
  if (
    process.env.AL_EX_FW_MODE === undefined ||
    process.env.BUILD_ENV === undefined
  ) {
    throw new Error(
      'framework 时序错误' +
        JSON.stringify({
          'process.env.AL_EX_FW_MODE':
            process.env.AL_EX_FW_MODE === undefined
              ? '#undefined#'
              : JSON.stringify(process.env.AL_EX_FW_MODE),
          'process.env.BUILD_ENV':
            process.env.BUILD_ENV === undefined
              ? '#undefined#'
              : JSON.stringify(process.env.BUILD_ENV),
        })
    )
  }
}
